import { render } from "./NumericField.vue?vue&type=template&id=feb1064e"
import script from "./NumericField.vue?vue&type=script&lang=js"
export * from "./NumericField.vue?vue&type=script&lang=js"

import "./NumericField.vue?vue&type=style&index=0&id=feb1064e&lang=css"
script.render = render

export default script